<template>
  <UserAvatar
    :user="item"
    :show-name="true"
    :tooltip-enabled="true"
    name-class="text-sm"
    :show-employee-id="showEmployeeId"
  >
    <template #additional-content>
      <div
        class="text-xs flex items-center justify-start gap-2 text-gray-500"
        v-if="view === 'attendenceTable'"
      >
        <span
          class="w-2 h-2 inline-block rounded-full ml-1 transition-all duration-300"
          :class="getCurrentDateClockIN(item) ? 'bg-green-500 glowing' : 'bg-red-500 dimmed'"
        ></span>
        {{ avalibility }}
      </div>
    </template>
  </UserAvatar>
</template>

<script>
import UserAvatar from '@/components/UserAvatar.vue'
import { fullName } from '@/utils/common'

export default {
  name: 'EmployeeProfile',
  components: {
    UserAvatar
  },
  props: {
    item: Object,
    view: String,
    showEmployeeId: Boolean
  },
  data() {
    return {
      avalibility: ''
    }
  },
  methods: {
    getCurrentDateClockIN(item) {
      if (item.attendance) {
        const today = this.$dayjs().format('DD MMM')
        const clockIn =
          item?.attendance[today] &&
          item?.attendance[today]?.CurrentStatus !== 'CHECKED_OUT' &&
          item?.attendance[today]?.CurrentStatus
        if (clockIn) {
          this.avalibility = 'Clocked-In'
        } else {
          this.avalibility = 'Clocked-Out'
        }
        return clockIn
      }
      return
    }
  }
}
</script>

<style scoped>
@keyframes glow {
  0% {
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.8);
  }
  50% {
    box-shadow: 0 0 15px rgba(0, 255, 0, 0.8);
  }
  100% {
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.8);
  }
}

@keyframes dim {
  0% {
    box-shadow: 0 0 5px rgba(255, 0, 0, 0.6);
  }
  50% {
    box-shadow: 0 0 15px rgba(255, 0, 0, 0.6);
  }
  100% {
    box-shadow: 0 0 5px rgba(255, 0, 0, 0.6);
  }
}

.glowing {
  animation: glow 2s infinite;
}

.dimmed {
  animation: dim 2s infinite;
}

.animate-bounce {
  animation: bounce 1s infinite;
}

.animate-pulse {
  animation: pulse 2s infinite;
}
</style>
